import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { IconCheck } from "@tabler/icons-react";

export default observer(function CalculationUptodateIndicator() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center ml-3 text-sm text-gray-600">
      <div className="bg-green-100 rounded-full mr-2 p-1 text-green-600">
        <IconCheck size={15} stroke={3} />
      </div>
      <span>{t("dashboard.evaluationsAreUpToDate")}</span>
    </div>
  );
});
